<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{ error_alert }}
        </v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}
        </v-alert
        >
      </v-col>
      <v-col cols="12">
        <v-card-title>
          Investigation Setup
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <template>
            <v-row align="center" justify="space-around">
              <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList()">Print</v-btn>
            </v-row>
          </template>
          <v-btn color="primary" @click="add_investigation_setup()">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <div id="print">
          <v-card>
            <v-data-table
                :headers="headers"
                :items="InvestigationDatas"
                class="elevation-1"
                :search="search"
                dense
                mobile-breakpoint="0"
                :loading="loadingstatus"
                loading-text="Loading... Please wait"
            >
              <template v-slot:item.status="{ item }">
                <v-chip v-if="item.status == 1" dark color="green" label outlined small
                >Active
                </v-chip>
                <v-chip v-if="item.status == 0" dark color="orange" label outlined small
                >Inactive
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        @click="get_edit_data(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                        color="orange"
                        label
                        outlined
                        small
                    >
                      <v-icon> mdi-pencil</v-icon>
                    </v-chip>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </div>

      </v-col>
    </v-row>


    <template>
      <div class="text-center">
        <v-dialog v-model="method_item_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Investigation Setup
              <span v-if="formdata.name">: {{ formdata.name }}</span></v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.name"
                          outlined
                          dense
                          label="Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.room"
                          outlined
                          dense
                          label="Room"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.one_eye_charge"
                          outlined
                          dense
                          label="One Eye Charge"
                          required
                          type="number"
                          :min="0"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                          v-model="formdata.both_eye_charge"
                          outlined
                          dense
                          label="Both Eye Charge"
                          required
                          type="number"
                          :min="0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdata.category"
                          :items="category"
                          item-value="key"
                          item-text="value"
                          label="Category"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdata.type"
                          :items="type"
                          item-value="key"
                          item-text="value"
                          label="Type"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formdata.status"
                          :items="status"
                          item-value="key"
                          item-text="value"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="method_item_dialog = false"> Cancel</v-btn>
              <v-btn text color="warning" @click="formdata = {}"> Reset</v-btn>
              <v-btn color="primary" text @click="InvestigationDataSubmit()"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
// import PermissionName from "@/js/PermissionName";

export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      method_item_dialog: false,
      error_alert: null,
      success_alert: null,
      loadingstatus: true,
      InvestigationDatas: [],
      category: [
        {key: "Investigations", value: "Investigations"},
        {key: "Investigation Other", value: "Investigation Other"},
        {key: "OPD", value: "OPD"},
        {key: "Pathology", value: "Pathology"},
      ],
      type: [
        {key: "Ocular", value: "Ocular"},
        {key: "Systemic", value: "Systemic"},
        {key: "Biochemical", value: "Biochemical"},
        {key: "Immunology", value: "Immunology"},
        {key: "Clinical Pathology", value: "Clinical Pathology"},
        {key: "Microbiology", value: "Microbiology"},
      ],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {text: "Name", value: "name"},
        {text: "Room Name", value: "room"},
        {text: "Charge(Single Eye)", value: "one_eye_charge"},
        {text: "Charge(Booth Eye)", value: "both_eye_charge"},
        {text: "Category", value: "category"},
        {text: "Type", value: "type"},
        {text: "Create Date", value: "created_at"},
        {text: "Status", value: "status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      desserts: [],
      autoheaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },

        {text: "Action", value: "actions", sortable: false},
      ],
      formdata: {
        id: null,
        name: null,
        room: null,
        one_eye_charge: null,
        both_eye_charge: null,
        category: null,
        type: null,
        status: null,
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Administrative",
          disabled: true,
          href: "patients",
        },
        {
          text: "Investigation",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      api_base_URL: atshq.defaults.headers.common.api_base_URL,

    };
  },
  // Fetches posts when the component is created.
  created() {
    let userGroups = JSON.parse(localStorage.getItem("userGroups")) || []; // Ensure it's an array
    let permittedGroups = [1,8]; // Admin=1, Manager=8 group ID
    let hasAccess = userGroups.some(group => permittedGroups.includes(Number(group)));

    if (hasAccess) {
      console.log("Access Granted");
    } else {
      this.loadingstatus = false;
      this.error_alert = "Invalid Request";
      return false;
    }
    this.get_investigation_data();

  },
  mounted() {
    // this.permissionExists(PermissionName.INVESTIGATION_SETUP);
  },
  methods: {
    get_investigation_data() {
      atshq
          .get("administrative/investigation-data")
          .then((response) => {
            this.InvestigationDatas = response.data.InvestigationDatas;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert.push(e);
          });
    },
    add_investigation_setup() {
      this.formdata.id = null;
      this.formdata.name = null;
      this.formdata.room = null;
      this.formdata.one_eye_charge = null;
      this.formdata.both_eye_charge = null;
      this.formdata.category = null;
      this.formdata.type = null;
      this.formdata.status = null;
      this.method_item_dialog = true;
    },
    get_edit_data(item) {
      this.method_item_dialog = true;
      this.formdata.id = item.id;
      this.formdata.name = item.name;
      this.formdata.room = item.room;
      this.formdata.one_eye_charge = item.one_eye_charge;
      this.formdata.both_eye_charge = item.both_eye_charge;
      this.formdata.category = item.category;
      this.formdata.type = item.type;
      this.formdata.status = parseInt(item.status);
    },
    InvestigationDataSubmit() {
      if (confirm("are you sure?"))
        if (this.formdata.id) {
          atshq
              .put("administrative/investigation-data/" + this.formdata.id, {
                data: this.formdata,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_investigation_data();
                this.method_item_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        } else {
          atshq
              .post("administrative/investigation-data", {
                formdata: this.formdata,
                user_id: localStorage.getItem("userId"),
              })
              .then((res) => {
                this.$noty.success(res.data.message);
                this.get_investigation_data();
                this.method_item_dialog = false;
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
              })
        }
    },
    printList() {
      window.open(this.api_base_URL + 'print/print-investigation-setup')
    },
  },
};
</script>
